import { render, staticRenderFns } from "./SjiHeaders.vue?vue&type=template&id=3cb83a6a&scoped=true"
import script from "./SjiHeaders.vue?vue&type=script&lang=js"
export * from "./SjiHeaders.vue?vue&type=script&lang=js"
import style0 from "./SjiHeaders.vue?vue&type=style&index=0&id=3cb83a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb83a6a",
  null
  
)

export default component.exports